import { ROOT_API_URL } from 'constant/api';
import compose from 'lodash.flowright';
import PropType from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router-dom';

import Client from './client';

const RestClientContext = React.createContext(() => {});

export const withRestClient = Component => props => (
  <RestClientContext.Consumer>
    {({ client }) => <Component client={client} {...props} />}
  </RestClientContext.Consumer>
);

class RestClient extends React.PureComponent {
  static propTypes = {
    history: PropType.object.isRequired,
    children: PropType.node.isRequired
  };

  constructor(props) {
    super(props);
    const { history } = props;
    this.client = new Client(ROOT_API_URL, history);
  }

  render() {
    return (
      <RestClientContext.Provider value={{ client: this.client }}>
        {this.props.children}
      </RestClientContext.Provider>
    );
  }
}

export default compose(withRouter)(RestClient);
